import { render, staticRenderFns } from "./inOutAreaList.vue?vue&type=template&id=497d7847&scoped=true"
import script from "./inOutAreaList.vue?vue&type=script&lang=js"
export * from "./inOutAreaList.vue?vue&type=script&lang=js"
import style0 from "./inOutAreaList.vue?vue&type=style&index=0&id=497d7847&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497d7847",
  null
  
)

export default component.exports